import React from 'react';

export const GradeContext = React.createContext();
